import { Button, Drawer, TextField } from '@mui/material'
import React, { useState } from 'react'
import { CrudAdministrativo } from '../../../api/admin/CrudAdministrativo.api';


import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import LockResetIcon from '@mui/icons-material/LockReset';
import LoaderData from '../../../component/LoaderData';

export const Administrativos = ({datosPrecargados}) => {
    // console.log(datosPrecargados)
    const [IsLoadding, setIsLoadding] = useState(false);

    const [administrativosList, setadministrativosList] = useState(datosPrecargados)
    const [administrativosListBKP, setadministrativosListBKP] = useState(datosPrecargados)
    const [selectedItem, setSelectedItem] = useState(null);

    const [cambioClave, setCambioClave] = useState("");

    const [nombreADM, setNombreADM] = useState("");
    const [rutADM, setRutADM] = useState("");
    const [userADM, setUserADM] = useState("");
    const [areaADM, setAreaADM] = useState("");
    const [claveADM, setClaveADM] = useState("");

    //CRUD ADMINISTRATIVO
    const crudAdministrativo = (action, data) => {

        //logica para crud
        const createAdmin = async (data) => {
            // console.log("CREATE", data)
            data["rol"] = "ADMINISTRATIVO";
            data["estado"] = true;
            data["aplicacion"] = "CONTROL-TRANSPORTE";
            data["empresa"] = "AGROINDUSTRIAL EL PAICO S.A."

            let respAdmin = await CrudAdministrativo({ data, action: "CREATE" })
            crudAdministrativo("READ");
            setState_A_C({...state_A_C,["bottom"]: false});
        }
        const readAdmin = async () => {
            let respAdmin = await CrudAdministrativo({ action: "READ" })
            setadministrativosList(respAdmin);
            setadministrativosListBKP(respAdmin);
        }
        const updateAdmin = async (data) => {
            // console.log("UPDATE", data)
            let isDelete = window.confirm("¿Esta seguro de editar el administrativo seleccionado?");
            if(isDelete) {
                let resp = await CrudAdministrativo({data, action: "UPDATE"});
                crudAdministrativo("READ");
                setState_A_E({...state_A_E,["bottom"]: false});
                alert("Administrativo editado correctamente");
            }
        }
        const deleteAdmin = async (data) => {
            // console.log("DELETE", data)
            let isDelete = window.confirm("¿Esta seguro de eliminar el administrativo seleccionado?");
            if(isDelete) {
                let resp = await CrudAdministrativo({data, action: "DELETE"});
                crudAdministrativo("READ");
                alert("Administrativo eliminado correctamente");
            }
        }

        const resetPassword = async (data) => {
            // console.log("RSTPASSWORD", data,cambioClave)
            let resp = await CrudAdministrativo({data:{_id:data, clave:cambioClave}, action: "RSTPASSWORD"});
            alert("Contraseña del administrativo se cambio correctamente");
            setCambioClave("")
            let btn = document.createElement("button");
            btn.setAttribute("type", "button");
            btn.setAttribute("data-dismiss", "modal");
            btn.click();
            setSelectedItem();
            setCambioClave("");
           
        }

        switch (action) {
            case "CREATE":
                createAdmin(data);
                return;
            case "READ":
                readAdmin();
                return;
        
            case "UPDATE":
                updateAdmin(data);
                return;

            case "DELETE":
                deleteAdmin(data);
                return;

            case "RSTPASSWORD":
                resetPassword(data);
                return;
            
        }
    }

    //DRAWER CREA ADMINISTRATIVO
    const [state_A_C, setState_A_C] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const toggleDrawer_A_C = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        if(anchor === "bottom" && open){
            //LOGIC WHEN DRAWER CLOSER
        }
        setState_A_C({ ...state_A_C, [anchor]: open });
        setNombreADM("");
        setRutADM("");
        setUserADM("");
        setAreaADM("");
        setCambioClave("");
    };

    //DRAWER EDITA ADMINISTRATIVO
    const [state_A_E, setState_A_E] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer_A_E = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        if(anchor === "bottom" && open){
            //LOGIC WHEN DRAWER CLOSER
        }
        setState_A_E({ ...state_A_E, [anchor]: open });
        setSelectedItem()
    };

    return (<>
        <div className='container'>
            <div className='row'>
                <div className='col-12 fondo-celeste container-header-minipage mb-4 pt-3'>
                    <h1 className='lead text-white'><b>Administrativos</b></h1>
                </div>
                <div className='col-12 text-center'>
                    <button
                        onClick={toggleDrawer_A_C("bottom", true)}
                        className='btn btn-sm btn-primary'
                    >Agregar Administrativo</button>
                </div>
                <div className='col-12 mt-2'>
                    {/* buscador de usuario */}
                    <div className='row'>
                        <div className='col-12 col-md-4 my-2'>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                id="outlined-basic"
                                size='small'
                                label="Buscar Administrativo"
                                placeholder='Busca por nombre o rut'
                                onChange={(e) => {
                                    let value = e.target.value.toUpperCase();
                                    if(value === ""){
                                        setadministrativosListBKP(administrativosList);
                                        return;
                                    }else{
                                        setadministrativosListBKP(administrativosList.filter(item => item.nombre.toUpperCase().includes(value) || item.rut.toUpperCase().includes(value)));
                                    }
                                }}
                                variant="outlined" />
                        </div>
                    </div>
                </div>
                <div className='col-12 mt-2'>
                    <table className='table table-sm table-striped table-hover'>
                        <thead className='fondo-gris text-white'>
                            <tr>
                                <th>N°</th>
                                <th>Rut</th>
                                <th>Nombre</th>
                                <th>Correo</th>
                                <th>Area</th>
                                <th className='text-center'>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                administrativosListBKP.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{item.rut}</td>
                                        <td>{item.nombre}</td>
                                        <td>{item.user}</td>
                                        <td>{item.nom_ceco}</td>
                                        <td className='text-center'>
                                        <span
                                            className='click hov'
                                            title='Editar'
                                            onClick={() => {
                                                setState_A_E({...state_A_E,["bottom"]: true});
                                                setSelectedItem(item);
                                            }}>
                                                <EditIcon color='success'/>
                                        </span>
                                        <span
                                            className='click hov mr-2'
                                            title='Restablecer Clave'
                                            data-toggle="modal" data-target="#exampleModal"
                                            data-backdrop="static" data-keyboard="false"
                                            // onClick={() =>crudAdministrativo("RSTPASSWORD", item._id)}
                                            onClick={() => {
                                                setSelectedItem(item);
                                            }}
                                        >
                                                <LockResetIcon color='warning'/>
                                        </span>
                                        <span className='click hov'
                                        title='Eliminar'
                                                onClick={() => crudAdministrativo("DELETE", item._id)}
                                            ><DeleteForeverIcon color='error' />
                                        </span>
                                        </td>
                                    </tr>
                                ))

                            }
                            
                        </tbody>
                    </table>
                </div>

                    <div className='col-12 text-center fondo-celeste container-footer-minipage mb-4 p-2 mt-3'>
                    <h1 className='lead text-white'><b>Control Transporte @{new Date().getFullYear()}.</b></h1>
                </div>
            </div>
        </div>

        {/* DRAWER PARA CREAR ADMINISTRATIVO */}
        <Drawer
            anchor={"bottom"}
            open={state_A_C["bottom"]}
            onClose={toggleDrawer_A_C("bottom", false)}
        >
            <div className='container-fluid mb-5'>
                <div className='row'>
                    <div className='col-12 text-white mb-5 py-3 mb-2 bg-dark'>
                        <span className='lead'>CREAR ADMINISTRATIVO</span>
                    </div>
                    <div className='col-12 col-md-4 mt-3'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="NOMBRE"
                            variant="outlined"
                            placeholder='NOMBRE APELLIDO APELLIDO'
                            value={nombreADM}
                            onChange={(e)=>setNombreADM(e.target.value)}
                        />
                    </div>
                    <div className='col-12 col-md-4 mt-3'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="RUT"
                            variant="outlined"
                            value={rutADM}
                            onChange={(e)=>setRutADM(e.target.value.toUpperCase())}
                        />
                    </div>
                    <div className='col-12 col-md-4 mt-3'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="CORREO"
                            variant="outlined"
                            value={userADM}
                            onChange={(e)=>setUserADM(e.target.value)}
                        />
                    </div>

                    <div className='col-12 col-md-2 mt-3'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="AREA"
                            variant="outlined"
                            value={areaADM}
                            onChange={(e)=>setAreaADM(e.target.value.toUpperCase())}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-3'>
                        <TextField
                            type='password'
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="CLAVE"
                            variant="outlined"
                            value={claveADM}
                            onChange={(e)=>setClaveADM(e.target.value)}
                        />
                    </div>

                    <div className='col-12 mt-2 text-right'>
                        <Button
                            variant="contained"
                            disabled={!claveADM || !nombreADM || !rutADM || !userADM || !areaADM || !userADM.includes("@")}
                            onClick={()=>crudAdministrativo("CREATE", {nombre: nombreADM, rut: rutADM, user: userADM, nom_ceco: areaADM, clave: claveADM})}>CREAR</Button>
                    </div>
                </div>
            </div>
        </Drawer>

            {/* DRAWER PARA EDITAR ADMINISTRATIVO */}
        <Drawer
            anchor={"bottom"}
            open={state_A_E["bottom"]}
            onClose={toggleDrawer_A_E("bottom", false)}
        >
            <div className='container-fluid mb-5'>
                <div className='row'>
                    <div className='col-12 text-white mb-5 py-3 mb-2 bg-dark'>
                        <span className='lead'>EDITAR ADMINISTRATIVO</span>
                    </div>
                    <div className='col-12 col-md-4 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="NOMBRE"
                            variant="outlined"
                            placeholder='NOMBRE APELLIDO APELLIDO'
                            value={selectedItem?.nombre}
                            onChange={(e)=>setSelectedItem({...selectedItem, nombre:e.target.value})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="RUT"
                            variant="outlined"
                            value={selectedItem?.rut}
                            onChange={(e)=>setSelectedItem({...selectedItem, rut:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-4 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="CORREO"
                            variant="outlined"
                            value={selectedItem?.user}
                            onChange={(e)=>setSelectedItem({...selectedItem, user:e.target.value})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="AREA"
                            variant="outlined"
                            value={selectedItem?.nom_ceco}
                            onChange={(e)=>setSelectedItem({...selectedItem, nom_ceco:e.target.value.toUpperCase()})}
                        />
                    </div>
                

                    <div className='col-12 mt-2 text-right'>
                        <Button
                            variant="contained"
                            onClick={()=>crudAdministrativo("UPDATE",selectedItem)}>EDITAR</Button>
                    </div>
                </div>
            </div>
        </Drawer>

        {/* MODAL CAMBIO CLAVE */}
        <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Cambiar Clave del administrativo</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body text-center">
                    <TextField
                        type='password'
                        value={cambioClave}
                        onChange={(e)=>setCambioClave(e.target.value)}
                        fullWidth
                        id="outlined-basic"
                        size='small'
                        label="Nueva Clave"
                        variant="outlined"
                    />
                    <small className='text-danger'>Ingese una clave sin espacios, mayor a 6 digitos y facil de recordar.</small>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        data-dismiss="modal"
                        onClick={()=>{
                            setSelectedItem()
                            setCambioClave("")
                        }}
                    >Cerrar</button>
                    <button
                        disabled={cambioClave.length < 6}
                        type="button"
                        data-dismiss="modal"
                        className="btn btn-sm btn-danger"
                        onClick={()=>crudAdministrativo("RSTPASSWORD",selectedItem)}
                    >Guardar cambios</button>
                </div>
                </div>
            </div>
        </div>

        {
            IsLoadding &&  <LoaderData />
        }
    </>
    )
}
